import { Divider, Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { WithdrawalRequestsList } from "./WithdrawalRequestsList";
import { useMemo } from "react";
import { BalancesBlock } from "./BalancesBlock";
import { RubOperationsList } from "./RubOperationsList";
import { CustomTabs } from "ui/CustomTabs";
import styles from "./NominalAccount.module.css";

const TABS_KEYS = {
  WITHDRAWAL_REQUESTS: "withdrawalRequests",
  RUB_OPERATIONS: "rubOperations",
};

export const NominalAccountPage = observer(() => {
  const tabItems = useMemo(
    () => [
      {
        key: TABS_KEYS.RUB_OPERATIONS,
        title: "Движение по счету",
        children: <RubOperationsList />,
      },
      {
        key: TABS_KEYS.WITHDRAWAL_REQUESTS,
        title: "Заявки на вывод",
        children: <WithdrawalRequestsList />,
      },
    ],
    []
  );

  return (
    <Flex vertical gap="large">
      <Flex vertical className="margin-top-xs">
        <Typography.Title className="margin-none">Номинальный счет</Typography.Title>
      </Flex>

      <Divider className="margin-top-none margin-bottom-none" />

      <Flex gap="large" wrap="wrap">
        <div>
          <BalancesBlock />
        </div>

        <CustomTabs items={tabItems} rootClassName={styles.tabsContainer} defaultActiveKey={TABS_KEYS.RUB_OPERATIONS} />
      </Flex>
    </Flex>
  );
});
